/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2024 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
"use client";
import { shiftWeekNames as i } from "../../utils.mjs";
class r {
  constructor(e) {
    this.intl = e;
  }
  getWeekNames(e = !1, t) {
    const s = i(
      this.intl.dateFormatNames({ nameType: t != null ? t : "short", type: "days" }),
      this.intl.firstDay()
    );
    return e ? [""].concat(s) : s;
  }
}
export {
  r as WeekNamesService
};
